import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Card, Row, Col, Button, Spinner } from 'react-bootstrap';
import { userStore } from '../../../store/UserStore';
import Loader from '../../../shared/common/loader';
import CustomerOnboardingHttp from '../services/customer.service';
import infoIco from 'assets/images/i-circle.svg';
import successIco from 'assets/images/check.png';
import errorIco from 'assets/images/i-error.svg';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OtpModal from 'shared/common/modal/otp_modal';
import { useHistory } from 'react-router-dom';
import SubAccountCreatePage from './create_sub_account';
import Search from 'shared/common/search';

interface PropsType {
  handleCreate: any;
  apiError: string;
}

const CustomerCreatePage: React.FC<PropsType> = ({
  handleCreate,
  apiError,
}) => {
  // eslint-disable-next-line
  const [user, setUser] = userStore((state: any) => [
    state.user,
    state.setUser,
  ]);
  const [txtSuscces, setTxtSuscces] = useState('');
  const [txtError, setTxtError] = useState('');
  const [loading, setLoading] = useState<any>(false);
  const [selectedFile, setSelectedFile] = useState<any>(true);
  const [panOcr, setPanOcr] = useState<any>('');
  const [panNumber, setPanNumber] = useState<any>('');
  const [aadhaarNumber, setAadhaarNumber] = useState<any>(0);
  const [customer, setCustomer] = useState<any>({
    account_type: 'IND',
    pan_number: '',
    aadhaar_number: '',
    aadhaar_aggree: false,
    name: '',
  });
  const [isPincodeDisabled, setIsPincodeDisabled] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [otp, setOtp] = useState<any>();
  const [resend, setResend] = useState(false);

  const [pincode, setPincode] = useState('');
  const [selectedState, setSelectedState] = useState({});

  const [isPanVerify, setPanVerify] = useState(true);
  const [isPanVerifing, setPanVerifing] = useState(false);
  const [isPanVerifySuccess, setPanVerifySuccess] = useState(false);
  const [isPanVerifyFeild, setPanVerifyFeild] = useState(false);

  const [isPanUploading, setPanUploading] = useState(false);
  const [isPanUploadSuccess, setPanUploadSuccess] = useState(false);
  const [isPanUploadFeild, setPanUploadFeild] = useState(false);
  const [show, setShow] = useState<any>(false);
  const [panDetails, setPanDetails] = useState<any>('');
  const [indName, setIndName] = useState<any>('');
  const [validation, setValidationSchema] = useState<any>({
    name: Yup.string().trim().required('Display Name is required'),

    aadhaar_agree: Yup.boolean()
      .required('The terms and conditions must be accepted.')
      .oneOf([true], 'The terms and conditions must be accepted.')
      .default(false),
  });
  const [isIndividualDisabled, setIndividualDisabled] = useState(false);

  const ref = useRef(null);

  const history = useHistory();

  useEffect((): any => {
    //setLoading(false);
    // eslint-disable-next-line

    if (isSoleIndCreated().length > 0) {
      setIndividualDisabled(true);
      setCustomer({
        account_type: 'HUF',
        pan_number: '',
        aadhaar_number: '',
        aadhaar_aggree: false,
        name: '',
      });
    }

    if (user?.kyc?.aadhaar?.isVerified) {
      setValidationSchema({
        name: Yup.string().trim().required('Display Name is required'),
        pincode: Yup.string()
          .trim()
          .required('Pincode is required')
          .test(
            'pincode-backend-validation',
            'Pincode not found in database',
            async (pincode) => {
              return await checkPincode(pincode);
            }
          ),
        aadhaar_agree: Yup.boolean()
          .required('The terms and conditions must be accepted.')
          .oneOf([true], 'The terms and conditions must be accepted.')
          .default(false),
      });
      setAadhaarNumber(user.kyc.aadhaar.value);
    } else {
      setValidationSchema({
        name: Yup.string().trim().required('Display Name is required'),
        pincode: Yup.string()
          .trim()
          .required('Pincode is required')
          .min(6, 'Pincode is invalid')
          .max(6, 'Pincode is invalid')
          .test(
            'pincode-backend-validation',
            'Pincode not found in database',
            async (pincode) => {
              return await checkPincode(pincode);
            }
          ),
        aadhaar_agree: Yup.boolean()
          .required('The terms and conditions must be accepted.')
          .oneOf([true], 'The terms and conditions must be accepted.')
          .default(false),
      });
    }
  }, [user]);

  useEffect(() => {
    if (isSoleIndCreated().length > 0) {
      history.push('/customers');
    }
  }, []);

  const isSoleIndCreated = () => {
    return user?.customers.filter((customer) => customer.customerType == 'IND');
  };

  const checkPincode = async (pincode) => {
    if (pincode?.length === 6) {
      try {
        setIsPincodeDisabled(true);
        const response: any = await CustomerOnboardingHttp.getStatebyPincode(
          pincode
        );
        if (response.status == 200 && response.data) {
          setPincode(pincode);
          setSelectedState(response.data?.data?.stateName);
          setIsPincodeDisabled(false);
          return true;
        }
      } catch (error) {
        setIsPincodeDisabled(false);
        return false;
      }
    } else {
      return false;
    }
  };

  const fileChanged = (event: any) => {
    setSelectedFile(event.target.files[0]);
    onFileUpload(event);
  };

  const onFileUpload = async (file) => {
    //setLoading(true);
    // Create an object of formData
    uploadInprograss();
    const formData = new FormData();

    // Update the formData object
    formData.append('myFile', file.target.files[0], file.target.files[0].name);

    try {
      const res: any = await CustomerOnboardingHttp.panOcr(formData);
      if (res.status === 200 && res.data.data) {
        setPanOcr(res.data.data.kycId);
        uploadSuccess();
        setLoading(false);
      } else {
        uploadFeild();
      }
    } catch (e: any) {
      uploadFeild();
    }
  };

  const aadhaarVerify = async (values: any) => {
    setLoading(true);
    try {
      // if (user?.kyc?.aadhaar?.isVerified) {
      createIndCustomer(values);
      //   return;
      // }
      // setAadhaarNumber(values.aadhaar_number);
      setCustomer({
        account_type: 'IND',
        // aadhaar_number: values.aadhaar_number,
        aadhaar_number: '',
        aadhaar_aggree: true,
        name: values.name,
      });
      // const res: any = await CustomerOnboardingHttp.sendAadhaarOtp({
      //   name: values.name,
      //   aadhaarNo: values.aadhaar_number,
      //   consent: true,
      // });
      // if (res && res.status === 200) {
      //   setModalShow(true);
      //   setTxtSuscces("OTP has been sent.");
      //   setTxtError("");
      // } else {
      //   setTxtError(res.data.errors[0].title);
      //   toast.error(res.data.errors[0].title);
      // }
      setLoading(false);
    } catch (err: any) {
      // setUsernameError(err.message);
      toast.error(err.data.errors[0].title);
      setLoading(false);
      //setError(err);
    }
  };

  const createIndCustomer = async (values) => {
    try {
      const customer_data = {
        customerType: 'IND',
        displayName: values.name,
        kyc: {},
      };

      const cus_res: any = await CustomerOnboardingHttp.createCustomer(
        customer_data,
        user?.userId
      );

      if (cus_res.status === 200 && cus_res.data) {
        const account_data = {
          customerId: cus_res.data.data.customerId,
          pinCode: pincode,
          stateName: selectedState,
        };
        const acc_res: any = await CustomerOnboardingHttp.createAccount(
          account_data,
          user?.userId
        );
        if (acc_res.status === 200 && acc_res.data) {
          toast.success('New customer account has been created.');
          history.push('/customers');
        }
      }
      setLoading(false);
    } catch (e: any) {
      toast.error(e.data.errors[0].title);
      setLoading(false);
    }
  };

  const toVerify = () => {
    setPanVerify(true);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifyInprograss = () => {
    setPanVerify(false);
    setPanVerifing(true);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifySuccess = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(true);
    setPanVerifyFeild(false);
  };

  const verifyFeild = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(true);
  };

  const uploadInprograss = () => {
    setPanUploading(true);
    setPanUploadSuccess(false);
    setPanUploadFeild(false);
  };

  const uploadSuccess = () => {
    setPanUploading(false);
    setPanUploadSuccess(true);
    setPanUploadFeild(false);
  };

  const uploadFeild = () => {
    setPanUploading(false);
    setPanUploadSuccess(false);
    setPanUploadFeild(true);
  };

  const panVerify = async (values: any, setErrors: any) => {
    let errors = {} as any;
    if (!ref.current.values.pan_number) {
      errors.pan_number = 'Please enter an valid pan number.';
      setErrors(errors);
      return;
    }
    verifyInprograss();
    try {
      const res: any = await CustomerOnboardingHttp.verifyPanNumber({
        pan: ref.current.values.pan_number,
      });
      if (res && res.status === 200) {
        setPanNumber(res.data.data.kycId);
        setPanDetails(res.data.data);
        setShow(true);
        verifySuccess();
      } else {
        verifyFeild();
        toast.error(res.data.errors[0].title);
      }
      setLoading(false);
    } catch (err: any) {
      verifyFeild();
      toast.error(err.data.errors[0].title);
    }
  };

  const createEntCustomer = async (values: any, setErrors: any) => {
    setLoading(true);

    let errors = {} as any;
    if (!isPanVerifySuccess) {
      errors.pan_number = 'You have entered an invalid pan number.';
    }
    if (!isPanUploadSuccess) {
      errors.pan_image = 'You have uploded an invalid pan image.';
    }
    setErrors(errors);
    if (!isPanVerifySuccess || !isPanUploadSuccess) {
      setLoading(false);

      return;
    }

    try {
      const customer_data = {
        customerType: customer.account_type,
        kyc: {
          pan: {
            kycId: panNumber,
          },
          pan_ocr: {
            kycId: panOcr,
          },
        },
      };

      const cus_res: any = await CustomerOnboardingHttp.createCustomer(
        customer_data,
        user?.userId
      );

      if (cus_res.status === 200 && cus_res.data) {
        handleCreate(cus_res.data.data);
      } else {
        toast.error(cus_res.data.errors[0].title);
      }
      setLoading(false);
    } catch (err: any) {
      toast.error(err.data.errors[0].title);
      setLoading(false);
    }
  };
  // const hadlePanNumberChanged = (e) => {
  //   const { value } = e.target;
  //   setFieldValue('pan_number', value);
  // }
  useEffect(() => {
    if (user?.displayName) {
      setIndName(user.displayName);
    }
  }, [user?.displayName]);
  return (
    <>
      <div>
        <div className='row justify-content-md-center'>
          <div className='col-md-6 col-md-offset-3'>
            <Card>
              <Card.Body className='p-5 pb-0'>
                <div>
                  <div className='text-center mb-3'>
                    <Card.Title>Create New Customer Account</Card.Title>
                    <Card.Subtitle>
                      Setup your account and start your bullion journey today
                    </Card.Subtitle>
                  </div>
                  {!show && (
                    <div className='form-group mb-2'>
                      <label className='form-label'>Account Type</label>
                      <select
                        className='form-control'
                        name='type'
                        onChange={(event) =>
                          setCustomer({
                            ...customer,
                            account_type: event.target.value,
                          })
                        }
                        disabled
                        value={customer.account_type}
                      >
                        <option
                          value={'IND'}
                          selected
                          disabled={isIndividualDisabled}
                        >
                          Individual
                        </option>
                        {/* <option value={'HUF'}>Hindu Undivided Family</option>
                        <option value={'SOLE'} disabled={isIndividualDisabled}>
                          Sole Partnership
                        </option>
                        <option value={'LLP'}>
                          Limited Liability Partnership
                        </option>
                        <option value={'CO'}>Company</option>
                        <option value={'TRUST'}>Trust</option>
                        <option value={'FIRM'}>Partnership Firm</option> */}
                      </select>
                    </div>
                  )}
                  {customer.account_type === 'IND' ? (
                    <Formik
                      enableReinitialize={false}
                      initialValues={{
                        name: user?.displayName || '',
                        pincode: '',
                        aadhaar_agree: false,
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        aadhaarVerify(values);
                      }}
                      validationSchema={Yup.object().shape(validation)}
                    >
                      {({
                        isSubmitting,
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        setFieldError,
                        setFieldValue,
                        setFieldTouched,
                      }) => (
                        <Form translate={undefined}>
                          <div className='form-group mb-2'>
                            <label className='form-label'>Display Name</label>
                            <Field
                              type='text'
                              placeholder='Your Name as per PAN Card. Eg: Raj Sharma'
                              name='name'
                              className='form-control'
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                const regex = /^[A-Za-z ]+$/; // Allows only letters and spaces

                                if (regex.test(value) || value === '') {
                                  setIndName(value);
                                  setFieldValue('name', value);
                                }
                              }}
                              value={indName}
                            />
                            {/* <div className='error'>
                              {errors.name && touched.name && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.name}
                                </small>
                              )}
                            </div> */}
                          </div>
                          {/* 
                        {user?.kyc?.aadhaar?.isVerified ? (
                          <div className="form-group mb-2">
                            <label className="form-label">Aadhaar Number</label>
                            <Field type="text" placeholder="" name="adr_no" className="form-control" disabled/>
                          </div>
                        ) : (
                          <div className="form-group mb-2">
                            <label className="form-label">Aadhaar Number</label>
                            <Field type="number" placeholder="" name="aadhaar_number" className="form-control" />
                            <div className='error'>
                              {errors.aadhaar_number && touched.aadhaar_number && (
                              <small
                                id="my-helper-text"
                              >
                                <img src={infoIco} alt="" />{errors.aadhaar_number}
                              </small>
                              )}
                            </div>
                          </div>
                        )} */}
                          <div className='form-group mb-2'>
                            <label className='form-label'>Pincode</label>
                            <div className='input-group mb-3'>
                              <Field
                                type='text'
                                placeholder=''
                                disabled={isPincodeDisabled}
                                name='pincode'
                                className='form-control'
                              // onChange={(e) => {
                              //   setFieldTouched('pincode', true);
                              //   onPincodeChange(
                              //     e,
                              //     setFieldError,
                              //     setFieldValue
                              //   );
                              // }}
                              />
                              {isPincodeDisabled && (
                                <div className='input-group-text px-2'>
                                  <Spinner animation='grow' size='sm' />
                                </div>
                              )}
                            </div>

                            <div className='error'>
                              {errors.pincode && touched.pincode && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.pincode}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className='form-group mt-5'>
                            <label className='form-label'>
                              <Field
                                type='checkbox'
                                placeholder=''
                                name='aadhaar_agree'
                                className='mx-1'
                              />
                              I Agree to the{' '}
                              <a
                                href='https://ebullion.in/terms-and-conditions/T&C.html'
                                target='_blank'
                              >
                                terms and conditions
                              </a>
                            </label>
                          </div>
                          <div className='form-group mb-4'>
                            <div className='error'>
                              {errors.aadhaar_agree && touched.aadhaar_agree && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.aadhaar_agree}
                                </small>
                              )}
                            </div>
                          </div>

                          {/*
                            <div className="form-group mb-2">
                              <input type="checkbox" id="aggre" name="aggre" value="1">I Agree to the terms and conditions</input>
                            </div> */}
                          <div className='row'>
                            <div className='form-group mt-2 mb-4'>
                              <Button
                                disabled={loading}
                                variant='primary'
                                className='w-100'
                                size='lg'
                                type='submit'
                              >
                                {!loading ? (
                                  'Create Customer'
                                ) : (
                                  <div
                                    className='spinner-border text-white'
                                    role='status'
                                  >
                                    <span className='visually-hidden'>
                                      Loading...
                                    </span>
                                  </div>
                                )}
                              </Button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  ) : !show ? (
                    <>
                      <Formik
                        enableReinitialize
                        innerRef={ref}
                        initialValues={{
                          pan_number: '',
                          pan_image: '',
                          pan_agree: false,
                        }}
                        onSubmit={(values, { setSubmitting, setErrors }) => {
                          setSubmitting(false);
                          panVerify(values, setErrors);
                          // createEntCustomer(values,setErrors);
                        }}
                        validationSchema={Yup.object().shape({
                          pan_number: Yup.string().required('PAN is required'),
                          pan_image: Yup.mixed().required(
                            'PAN image is required'
                          ),
                          pan_agree: Yup.boolean()
                            .required(
                              'The terms and conditions must be accepted.'
                            )
                            .oneOf(
                              [true],
                              'The terms and conditions must be accepted.'
                            )
                            .default(false),
                        })}
                      >
                        {({
                          isSubmitting,
                          errors,
                          touched,
                          values,
                          setFieldValue,
                          setErrors,
                        }) => (
                          <Form translate={undefined}>
                            <div className='form-group mb-2'>
                              <label className='form-label'>
                                Enter your PAN
                              </label>
                              <div className='input-group mb-3'>
                                <Field
                                  type='text'
                                  className='form-control'
                                  name='pan_number'
                                  aria-label='Text input with checkbox'
                                  value={values.pan_number}
                                  onChange={(e) => {
                                    if (e.target.value) {
                                      toVerify();
                                      setFieldValue(
                                        'pan_number',
                                        e.target.value?.toUpperCase()
                                      );
                                    }
                                  }}
                                />
                                <div className='input-group-text'>
                                  {/*<button className="btn" type="button" onClick={ (values) => {panVerify(values,setErrors)}} id="button-addon2">*/}
                                  {/*  {isPanVerify ? (<div>Verify</div>) : ('')}*/}
                                  {/*  {isPanVerifing ? (*/}
                                  {/*  <div className="spinner-grow text-success" style={{width: '1rem', height:'1rem'}} role="status">*/}
                                  {/*    <span className="visually-hidden">Loading...</span>*/}
                                  {/*  </div>*/}
                                  {/*  ) : ('')}*/}
                                  {/*  {isPanVerifySuccess ? (<img style={{width: '20px'}} src={successIco} alt="" />) : ('')}*/}
                                  {/*  {isPanVerifyFeild ? (<img src={infoIco} alt="" />) : ('')}*/}
                                  {/*  */}
                                  {/*</button>*/}
                                </div>
                              </div>
                              {/* <Field type="text" placeholder="" name="pan_number" className="form-control" /> */}
                              <div className='error'>
                                {errors.pan_number && touched.pan_number && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.pan_number}
                                  </small>
                                )}
                              </div>
                              {/* <div className='error'>
                            {errors.pan_number_verify && touched.pan_number_verify && (
                            <small
                              id="my-helper-text"
                            >
                              <img src={infoIco} alt="" />{errors.pan_number_verify}
                            </small>
                            )}
                          </div> */}
                            </div>
                            <div className='form-group mb-2'>
                              <label className='form-label'>PAN Image</label>
                              <div className='input-group mb-3'>
                                <Field
                                  type='file'
                                  placeholder=''
                                  name='pan_image'
                                  className='form-control'
                                  value={values.pan_image}
                                  onChange={(e) => {
                                    fileChanged(e);
                                    setFieldValue('pan_image', e.target.value);
                                  }}
                                />
                                {isPanUploading ||
                                  isPanUploadSuccess ||
                                  isPanUploadFeild ? (
                                  <div className='input-group-text px-2'>
                                    {isPanUploading ? (
                                      <div
                                        className='spinner-grow text-success'
                                        style={{
                                          width: '1rem',
                                          height: '1rem',
                                        }}
                                        role='status'
                                      >
                                        <span className='visually-hidden'>
                                          Loading...
                                        </span>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                    {isPanUploadSuccess ? (
                                      <img
                                        style={{ width: '20px' }}
                                        src={successIco}
                                        alt=''
                                      />
                                    ) : (
                                      ''
                                    )}
                                    {isPanUploadFeild ? (
                                      <img src={infoIco} alt='' />
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                              <div className='error'>
                                {errors.pan_image && touched.pan_image && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.pan_image}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className='form-group mb-4'>
                              <div className='error'>
                                {errors.pan_agree && touched.pan_agree && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.pan_agree}
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className='form-group mt-5'>
                              <label className='form-label'>
                                <Field
                                  type='checkbox'
                                  placeholder=''
                                  name='pan_agree'
                                  className='mx-1'
                                />
                                I Agree to the{' '}
                                <a
                                  href='https://ebullion.in/terms-and-conditions/T&C.html'
                                  target='_blank'
                                >
                                  terms and conditions
                                </a>
                              </label>
                            </div>
                            <div className='error'>
                              {errors.pan_agree && touched.pan_agree && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.pan_agree}
                                </small>
                              )}
                            </div>
                            {/*
                            <div className="form-group mb-2">
                              <input type="checkbox" id="aggre" name="aggre" value="1">I Agree to the terms and conditions</input>
                            </div> */}
                            <div className='row'>
                              <div className='form-group my-4'>
                                <Button
                                  disabled={loading}
                                  variant='primary'
                                  className='w-100'
                                  size='lg'
                                  type='submit'
                                >
                                  {!loading ? (
                                    'Verify'
                                  ) : (
                                    <div
                                      className='spinner-border text-white'
                                      role='status'
                                    >
                                      <span className='visually-hidden'>
                                        Loading...
                                      </span>
                                    </div>
                                  )}
                                </Button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </>
                  ) : (
                    <>
                      <Formik
                        enableReinitialize
                        innerRef={ref}
                        initialValues={{
                          number: panDetails.pan,
                          name: panDetails.name,
                        }}
                        onSubmit={(values, { setSubmitting, setErrors }) => {
                          setSubmitting(false);
                          createEntCustomer(values, setErrors);
                        }}
                        validationSchema={Yup.object().shape({
                          number: Yup.string().required('PAN is required'),
                          name: Yup.mixed().required('PAN name is required'),
                        })}
                      >
                        {({
                          isSubmitting,
                          errors,
                          touched,
                          values,
                          setFieldValue,
                          setErrors,
                        }) => (
                          <Form translate={undefined}>
                            <div className='form-group mb-2'>
                              <label className='form-label'>PAN</label>
                              <div className='input-group mb-3'>
                                <Field
                                  type='text'
                                  className='form-control'
                                  name='number'
                                  aria-label='Text input with checkbox'
                                  disabled
                                  value={values.number}
                                  onChange={(e) => {
                                    toVerify();
                                    setFieldValue('number', e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className='form-group mb-2'>
                              <label className='form-label'>PAN Name</label>
                              <div className='input-group mb-3'>
                                <Field
                                  type='text'
                                  placeholder=''
                                  name='name'
                                  className='form-control'
                                  value={values.name}
                                  onChange={(e) => {
                                    fileChanged(e);
                                    setFieldValue('name', e.target.value);
                                  }}
                                  disabled
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='form-group my-4'>
                                <Button
                                  onClick={() => {
                                    setShow(false);
                                  }}
                                  variant='primary'
                                  className='bg-white btn btn-lg btn-secondary float-end mx-1'
                                  size='lg'
                                  style={{ color: '#2575fc' }}
                                  type='button'
                                >
                                  Cancel
                                </Button>
                                <Button
                                  disabled={loading}
                                  variant='primary'
                                  className='float-end'
                                  size='lg'
                                  type='submit'
                                >
                                  {!loading ? (
                                    'Verify'
                                  ) : (
                                    <div
                                      className='spinner-border text-white'
                                      role='status'
                                    >
                                      <span className='visually-hidden'>
                                        Loading...
                                      </span>
                                    </div>
                                  )}
                                </Button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      {/* <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title={"Enter the OTP sent your Aadhar registered Mobile Number"}
        onSuccess={(otp) => onAadhaarSuccess(otp)}
        resend={resendOtp}
        txtSuscces={txtSuscces}
        txtError={txtError}
      /> */}
    </>
  );
};

export default CustomerCreatePage;
